import React from 'react';
import Button from '../Button';
import './Hero.scss';

function Hero() {
  return (
    <section className="wtm-hero">
      <div className="contentWrapper">
        <div className="container">
          <div className="left-group">
            <img className="animate left-item left-polygon" src="/img/hero/groupLeft.png" alt="" />
            <img className="animate left-item left-bottom" src="/img/hero/Group120.png" alt="" />
            <img className="animate left-item left-top" src="/img/hero/speakLoud.png" alt="" />
          </div>
          <div className="right-group">
            <img
              className="animate right-item right-polygon"
              src="/img/hero/Group304.png"
              alt=""
            />
            <img
              className="animate right-item right-bottom"
              src="/img/hero/makeItHappen.png"
              alt=""
            />
            <img className="animate right-item right-top" src="/img/hero/goWild.png" alt="" />
          </div>
          <div className="center-group">
            <h1 className="big-title">
              Women
              <br />
              TechMakers
              <br />
              Seoul
              <br />
              2019
            </h1>
            <Button
              btnText="피드백 남기기"
              extraClassName="btn-main-event btn-lg btn-outline"
              absoluteUrl={"https://forms.gle/4c2U832qq7XKN3237"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(Hero);
